import React from 'react';

interface TextAreaInputProps {
    name: string
    label: string;
    subLabel?: string;
    placeholder?: string;
    rows?: number;
    error?: boolean;
    required?: boolean;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({
                                                         name,
                                                         label,
                                                         subLabel,
                                                         placeholder,
                                                         rows = 3,
                                                         error = false,
                                                         required = false
                                                     }) => {
    return (
        <div className="form-field">
            {label && <label className={`field-label ${required ? 'required-field' : ''}`}>{label}</label>}
            {subLabel && <div className="sub-label">{subLabel}</div>}
            <textarea
                className={`text-area ${error ? 'error-border' : ''}`}
                placeholder={placeholder}
                rows={rows}
                name={name}
            />
        </div>
    );
};

export default TextAreaInput;